module.exports = __webpack_public_path__ + "img/movers_thumbnail-600x450.83f0bc54.jpg";